import { Profile } from 'models'

/**
 * Create internal account from Backend metadatas
 * @param {Object} ufinityProfile
 * @param {Object} nagraProfile
 * @returns {Profile}
 */
export const profileFactory = (ufinityProfile, nagraProfile) => {
    return new Profile({
        ...nagraProfile,
        userId: ufinityProfile.userId,
        customerId: nagraProfile.userId,
        username: ufinityProfile.username,
        email: ufinityProfile.email,
        firstName: ufinityProfile.firstName,
        paymentMethods: ufinityProfile.paymentMethods,
        namedProperties: {
            nagra: nagraProfile,
            ufinity: ufinityProfile,
        },
        dvrQuotaUnit: Profile.DVR_QUOTA_UNIT.HOUR,
    })
}
